// services/callService.ts
import axios from "axios";
import { Call, BaseCall } from "../../types/features/support/Call";
import { PaginatedResponse } from "../../types/utils/PaginatedResponse";
import { MAIN_API_URL } from "../../config/api";

export const callService = {
  // Retourne une réponse paginée
  async getCalls(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Call>> {
    const response = await axios.get<PaginatedResponse<Call>>(`${MAIN_API_URL}/calls`, {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  async getCallById(id: string): Promise<Call | null> {
    const response = await axios.get<Call>(`${MAIN_API_URL}/calls/${id}`);
    return response.data;
  },

  async getCallsByClient(clientId: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Call>> {
    const response = await axios.get<PaginatedResponse<Call>>(`${MAIN_API_URL}/calls`, {
      params: { client_id: clientId, page, per_page: perPage },
    });
    return response.data;
  },

  async createCall(call: Omit<Call, "id" | "created_at" | "updated_at">): Promise<Call> {
    const response = await axios.post<Call>(`${MAIN_API_URL}/calls`, call);
    return response.data;
  },

  async updateCall(id: string, data: Partial<BaseCall>): Promise<Call> {
    const response = await axios.put<Call>(`${MAIN_API_URL}/calls/${id}`, data);
    return response.data;
  },

  async deleteCall(id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/calls/${id}`);
  },

  // Statistiques des appels
  async getStats(agentId?: string): Promise<CallStats> {
    const response = await axios.get<CallStats>(`${MAIN_API_URL}/calls/stats`, {
      params: { agent_id: agentId },
    });
    return response.data;
  },
};

export interface CallStats {
  total: number;
  entrants: number;
  sortants: number;
  duree_moyenne: number;
}
